import * as types from "../types/martHealthDashboard.types";
import { getOrderNotPartialList, getMartHealthDashboardList } from '../../services/martHealthDashboard.service';
import { validationErrors } from "../../utils/Helpers";

export const getOrderNotPartialListAction = (data, navigate) => {
  return async (dispatch, getState)  => {
    try {
      await getOrderNotPartialList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_ORDER_NOT_PARTIAL_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getMartHealthDashboardListAction = (data, navigate) => {
  return async (dispatch, getState)  => {
    try {
      await getMartHealthDashboardList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_MART_HEALTH_DASHBOARD_LIST_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};
